<template>
  <loading-container :loading="payoneerAuthorizeLoading">
  </loading-container>
</template>


<script>
  import { mapGetters, mapActions } from "vuex";

  import LoadingContainer from "@/components/Misc/LoadingContainer";

export default {
    name: "PayoneerAuthorize",
    components: {
      LoadingContainer,
    },
    beforeMount() {
      const query = this.$route.query;
      const code = query.code;
      if (code) {
        this.payoneerAuthorize(code);
      } else {
        this.$router.push({ name: 'autoPayment' });
      }
    },
    computed: {
      ...mapGetters({
        payoneerAuthorizeLoading: "auth/payoneerAuthorizeLoading",
      }),
    },
    methods: {
      ...mapActions({
        payoneerAuthorize: "auth/payoneerAuthorize",
        redirectSetting: "auth/redirectSetting",
      }),
    }
  };
</script>
